"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractErrorTrace = void 0;
const tslib_1 = require("tslib");
const client_common_1 = require("@neo-one/client-common");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const extractError = (action) => {
    if (action.type === 'Log') {
        return undefined;
    }
    const args = action.args;
    try {
        const event = client_common_1.smartContractConverters.toString(args[0]);
        if (event !== 'error') {
            return undefined;
        }
        return {
            address: action.address,
            line: client_common_1.smartContractConverters.toInteger(args[2], { type: 'Integer', decimals: 0 }).toNumber(),
            message: client_common_1.smartContractConverters.toString(args[1]),
        };
    }
    catch (_a) {
        return undefined;
    }
};
const extractTrace = (action) => {
    if (action.type === 'Log') {
        return undefined;
    }
    const args = action.args;
    try {
        const event = client_common_1.smartContractConverters.toString(args[0]);
        if (event !== 'trace') {
            return undefined;
        }
        return {
            address: action.address,
            line: client_common_1.smartContractConverters.toInteger(args[1], { type: 'Integer', decimals: 0 }).toNumber(),
        };
    }
    catch (_a) {
        return undefined;
    }
};
const extractTraces = (actions) => {
    const mutableTraces = [];
    for (const action of actions) {
        const trace = extractTrace(action);
        if (trace === undefined) {
            return mutableTraces;
        }
        mutableTraces.push(trace);
    }
    return mutableTraces;
};
const DEFAULT_ERROR = {
    trace: [],
};
exports.extractErrorTrace = (actions) => {
    const lastError = lodash_1.default.reverse([...actions])
        .map((action) => ({ action, error: extractError(action) }))
        .find(({ error }) => error !== undefined);
    if (lastError === undefined) {
        return DEFAULT_ERROR;
    }
    return {
        error: lastError.error,
        trace: extractTraces(actions.slice(actions.indexOf(lastError.action) + 1)),
    };
};

//# sourceMappingURL=extractErrorTrace.js.map
